import { MatStepper, MatVerticalStepper } from '@angular/material/stepper';
import { FormBuilder, Validators, FormGroup, FormControl } from "@angular/forms";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { RiesgoService } from "../../service/riesgo/riesgo.service";
import { ProformaDetalle } from "../../models/ProformaDetalle";
import * as moment from "moment";
import { NotificacionService } from "../../service/notificaciones/notificacion.service";
import { ProformasService } from "../../service/operaciones/proformas/proformas.service";
import { DatePipe, DecimalPipe } from "@angular/common";
import { EncryptDecryptService } from "../../service/security/encrypt-decrypt.service";
import { EvaluacionService } from 'src/app/service/evaluacion/evaluacion.service';
declare var $: any;
@Component({
  selector: 'app-respuesta-precalifica',
  templateUrl: './respuesta-precalifica.component.html',
  styleUrls: ['./respuesta-precalifica.component.scss'],
  providers: [DatePipe, DecimalPipe]
})
export class RespuestaPrecalificaComponent implements OnInit {
  @ViewChild("resetInput", { static: false }) InputVar: ElementRef;
  @ViewChild('spanVNPP', { static: true }) spanVNPP: ElementRef;
  @ViewChild('spanPlazo', { static: true }) spanPlazo: ElementRef;
  //@ViewChild('stepper', { static: true }) stepper: MatStepper;
  @ViewChild('stepper', { static: true }) public stepper: MatVerticalStepper;

  isLinear = true;
  generandoPdf: boolean;
  arrSimuladorFinalResumen: any = [];
  isLoading: boolean;
  disableDownload: boolean;

  loadingPrincipal: boolean = false;
  titulo: string = "Evalúa tu factura";
  monedaArr = [{ key: "2", value: "SOLES" }];
  rucAdq: any = "";
  mensaje: string = "";
  viewMessage:boolean = false;
  ProformaCompleta: any;
  form: any;
  formCel: any;
  moneda: any = 0;
  idProforma: any;
  TEM: number;
  proformaDetalle: ProformaDetalle[] = [];
  monto: any = 0;
  plazo: any;
  ranking: any = 0;
  remanente: any = 0;
  prov: any;
  correo: any;
  cel: any;
  formTEM: FormGroup;
  codSms: any;
  validaSms: boolean = null;
  ProformaResume: any = {
    VNPP: 0,
    Adelanto: 0,
    Interes: 0,
    Comision: 0,
    IGV_TOTAL: 0,
    Desembolso: 0,
    Remanente: 0,
  };
  ProformaDetail: any = {
    Fecha_de_Pago: "",
    Plazo: 0,
    VNPP: "0",
    Valor_Venta: "0",
    IGV_Factura_Porcentaje: 0.18,
    IGV_Factura_Importe: "0",
    Precio_Venta: "10",
    Total_Honorario: "0.00",
    Retencion_RH_Porcentaje: "0.0000",
    Retencion_RH_Importe: "0.00",
    Total_Recibido: "0.00",
    Detraccion_Porcentaje: 0.0,
    Detraccion_Importe: "0",
    Retencion_Porcentaje: 0.0,
    Retencion_Base: "72",
    Retencion_Importe: 0.0,
    Fondo_Garantia_Porcentaje: 0.0,
    Fondo_Garantia_Base: "72",
    Fondo_Garantia_Importe: 0.0,
    Otros_Descuentos: 0.0,
    Adelanto: 0.0,
    Interes: 0,
    Comision: 0.0,
    Desembolso: 0,
    Remanente: 0,
    IGV: 0,
  };
  ProformaX: any = {
    Num_Doc_Identificacion_Prov: "",
    Num_Doc_Identificacion_ADQ: "",
    Fecha: "",
    Tipo_Comprobante: "F",
    Fecha_Desembolso: "",
    Moneda: "",
    TEM: "",
    TEM_Sistema: "",
    Precio_Venta: "0.00",
    Total_Recibido: "0.00",
    VNPP: "",
    Adelanto_Porcentaje: "0",
    Adelanto_Importe: "0",
    Interes_Importe: "0",
    Comision_Importe: "0.00",
    IGV_Porcentaje: "0.18",
    IGV_Importe: 0,
    Desembolso_Importe: "0",
    Remanente_Importe: "0",
    TC_Compra: "3.33",
    TC_Venta: "3.34",
    Observaciones:"",
    SimuladorDetalle: [],
  };
  ProformaConDetalle: any = {
    pPAdelanto: "",
    TEM: "",
    VNPP: "0",
    Plazo: 0,
    Moneda: "",
  };
  data: any;
  showValid: boolean;
  loadingBtnValid: boolean;
  showInputCel: boolean;
  loadingBtnCel: boolean;
  showMessgValid: boolean;
  showMessgError: boolean;
  loading: boolean;
  decryptedCodValid: any;
  encryptedCodValid: any;
  showResProforma: boolean;
  resProforma: any;
  arrSimuladorFinal = {
    Url_Simulador: "",
    UrlResumen_Simulador: "",
    tipoCambio: "",
    VNPP: "0.00",
    Interes: 0.00,
    Desembolso: 0.00,
    Remanente: 0.00
  };
  isValid: any;
  nombreCompleto:string;
  nombre:string;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private riesgosService: RiesgoService,
    private notificacionService: NotificacionService,
    private proformaService: ProformasService,
    private datepipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private encryptDecryptService: EncryptDecryptService,
    private evaluacionService: EvaluacionService
  ) {
    let now = moment();
    this.ranking = this.riesgosService.top10K;
    this.rucAdq = this.riesgosService.rucAdq;

    this.form = this.formBuilder.group({
      moneda: ["", Validators.required],
      monto: ["", [Validators.required, Validators.min(1)]],
      plazo: ["", [Validators.required, Validators.min(10), Validators.max(180)]],
      Fecha_Desembolso: [now],
    });

    this.formCel = this.formBuilder.group({
      Cel: ["", [Validators.required, Validators.minLength(9), Validators.pattern("^9[0-9]{8}$")]],
      codSms: ["", [Validators.required, Validators.pattern("[0-9]{4}")]],
    });

    this.formTEM = new FormGroup({
      Plazo: new FormControl("", [Validators.required, Validators.min(10), Validators.max(180)]),
      VNPP: new FormControl("", [Validators.required, Validators.min(1)]),
      'NombreComercialProv': new FormControl(''),
      'NombreComercialAdq': new FormControl(''),
      ProveedorScore: new FormControl(""),
      AdquirenteScore: new FormControl(""),
      Num_Doc_Identificacion_Prov: new FormControl("00000000000"),
      Num_Doc_Identificacion_ADQ: new FormControl("00000000000"),
      ValorTipoCambio: new FormControl(3.33),
      TipoCambio: new FormControl("S", [Validators.required]),
      Adelanto_Porcentaje: new FormControl(90),
      Tipo_Comprobante: new FormControl("F"),
      Fecha_Desembolso: new FormControl(now),
      'Ranking': new FormControl(''),
      'Interes_Adquirente': new FormControl(0),
      'Tipo_Servicio': new FormControl(132),
      'Importe_Adquirente': new FormControl(0),
      Observaciones: new FormControl(''),
    });
  }

  ngOnInit() {
    this.verEstadoEvaluacion();
    this.showValid = false;
    this.loadingBtnValid = false;
    this.showInputCel = false;
    this.loadingBtnCel = false;
    this.showMessgValid = false;
    this.showMessgError = false;
    this.loading = false;
    this.showResProforma = false;
    this.nombreCompleto = localStorage.getItem("Nombre");
    this.nombre = this.nombreCompleto.split(' ')[0]
  }

  verEstadoEvaluacion() {
    this.loadingPrincipal = true;
    /* OBTENER RANKING AL ENTRAR EN LA PÁGINA, USANDO COMO PARAM EL rucAdq DE LA RUTA */
    this.route.params.subscribe(
      res => {
        this.rucAdq = res['rucAdq'];
        this.riesgosService.obtenerRanking(this.rucAdq).subscribe(
          res => {
            this.loadingPrincipal = false;
            this.ranking = res;
            // EL MENSAJE SE MUESTRA UN POCO DESPUÉS (1-2 SEG) DE LA CARGA DEL COMPONENTE
            if (this.ranking == null) {
              this.router.navigate(["evalua-tu-factura"]);
            } else if (this.ranking > 0 && this.ranking <= 3000) {
              this.viewMessage = true;
              this.monedaArr.push({ key: "3", value: "DÓLARES" });
            } else if (this.ranking > 3000 && this.ranking <= 6000) {
              this.viewMessage = true;
              this.monedaArr.push({ key: "3", value: "DÓLARES" });
              this.monedaArr = this.monedaArr.filter(function (item){
                return item.value !== 'SOLES'
              })
              this.formTEM.controls["TipoCambio"].setValue('3')
              this.mensaje = `Su cliente tiene facturas a negociar disponible en moneda dólares`;
            }
          },
          err => {
            this.loadingPrincipal = false;
            console.log("Error desde obtener ranking: ", err);
            this.router.navigate(["evalua-tu-factura"]);
          }
        );
      },
      err => {
        this.loadingPrincipal = false;
        console.log("Error desde ruta: ", err);
      }
    );
  }

  validarCodSms() {
    this.loadingBtnValid = true;
    this.showValid = false;
    this.showMessgValid = false;
    this.showMessgError = false;
    setTimeout(() => {
      this.decryptedCodValid = this.encryptDecryptService.decrypt(localStorage.getItem("codValid"));
      if (this.decryptedCodValid == this.formCel.get("codSms").value) {
        this.loadingBtnValid = false;
        this.showInputCel = false;
        this.showMessgValid = true;
        this.stepper.selected.completed = true;
        this.stepper.next();
      } else {
        this.loadingBtnValid = false;
        this.showMessgError = true;
      }
    }, 500);
  }
  limpiarInput() {
    this.InputVar.nativeElement.value = "";
  }

  isVNPPValid() {
    let VNPPValid: boolean;
    /* TODO: CAPTURAR VNPP DEL FORM Y VALIDAR SI CUMPLE CON LA VALIDACION O NO (MOSTRAR CHECK O X) */
    if (this.formTEM.get('VNPP') && this.formTEM.get('VNPP').valid) {
      this.spanVNPP.nativeElement.innerHTML = "<i class='fas fa-check text-success'></i>";
      VNPPValid = true;
    } else if (this.formTEM.get('VNPP') && this.formTEM.get('VNPP').dirty && this.formTEM.get('VNPP').invalid) {
      this.spanVNPP.nativeElement.innerHTML = "<i class='fas fa-check text-danger'></i>";
      VNPPValid = false;
    }
    return VNPPValid;
  }

  isPlazoValid() {
    let PlazoValid: boolean;
    /* TODO: CAPTURAR Plazo DEL FORM Y VALIDAR SI CUMPLE CON LA VALIDACION O NO (MOSTRAR CHECK O X) */
    if (this.formTEM.get('Plazo') && this.formTEM.get('Plazo').valid) {
      this.spanVNPP.nativeElement.innerHTML = "<i class='fas fa-check text-success'></i>";
      PlazoValid = true;
    } else if (this.formTEM.get('Plazo') && this.formTEM.get('Plazo').dirty && this.formTEM.get('Plazo').invalid) {
      this.spanVNPP.nativeElement.innerHTML = "<i class='fas fa-check text-danger'></i>";
      PlazoValid = false;
    }
    return PlazoValid;
  }

  generarCodigoValidacion(min: number, max: number) {
    this.codSms = Math.floor(Math.random() * (max - min + 1) + min);
  }

  showInputSMS() {
    this.showInputCel = true;
    this.limpiarInput();
  }

  enviarSms() {
    this.showInputCel = true;
    this.loadingBtnCel = true;
    this.showMessgValid = false;
    this.showMessgError = false;
    this.generarCodigoValidacion(1000, 9999);
    this.data = {
      numero: this.formCel.get("Cel").value,
      mensaje: "Su código de validación es " + this.codSms,
    };
    setTimeout(() => {
      this.notificacionService.sendSms(this.data).subscribe(
        res => {
          this.loadingBtnCel = false;
          this.showInputCel = false;
        },
        error => {
          this.loadingBtnCel = false;
          this.showInputCel = false;
          console.log(error);
        }
      );
    }, 500);

    localStorage.setItem("codValid", this.encryptDecryptService.encrypt("" + this.codSms));

    this.limpiarInput();
  }

  guardarProforma() {
    this.ProformaX.Observaciones = this.formTEM.controls["Observaciones"].value;
    this.ProformaX.Tipo_Servicio = 132;
    this.ProformaX.Porcentaje_Interes_Adquirente = 0;

    this.ProformaX.SimuladorDetalle = [];
    //this.ProformaX.VNPP = Number(this.formTEM.controls["VNPP"].value); // TRANSFORMO VNPP DE VUELTA A NUMBER PARA PORDER HACER LOS CALCULOS
    this.ProformaX.VNPP = this.formTEM.controls["VNPP"].value;
    this.ProformaX.Fecha = this.datepipe.transform(
      new Date(),
      "yyyy-MM-dd hh:mm:ss"
    );
    this.ProformaX.Adelanto_Porcentaje =
      this.formTEM.controls["Adelanto_Porcentaje"].value / 100;
    this.ProformaX.Moneda = this.formTEM.controls["TipoCambio"].value;
    this.ProformaX.Fecha_Desembolso = this.datepipe.transform(
      this.formTEM.controls["Fecha_Desembolso"].value,
      "yyyy-MM-dd"
    );
    //this.ProformaX.Precio_Venta = Number(this.formTEM.controls["VNPP"].value); // TRANSFORMO VNPP DE VUELTA A NUMBER PARA PORDER HACER LOS CALCULOS
    this.ProformaX.Precio_Venta = this.formTEM.controls["VNPP"].value;
    this.ProformaX.Num_Doc_Identificacion_Prov = this.formTEM.controls[
      "Num_Doc_Identificacion_Prov"
    ].value;
    this.ProformaX.Num_Doc_Identificacion_ADQ = this.formTEM.controls[
      "Num_Doc_Identificacion_ADQ"
    ].value;
    this.ProformaX.Tipo_Comprobante = this.formTEM.controls[
      "Tipo_Comprobante"
    ].value;
    //this.ProformaDetail.Precio_Venta = Number(this.formTEM.controls["VNPP"].value); // TRANSFORMO VNPP DE VUELTA A NUMBER PARA PORDER HACER LOS CALCULOS
    this.ProformaDetail.Precio_Venta = this.formTEM.controls["VNPP"].value;
    this.ProformaDetail.IGV_Factura_Importe = (
      this.ProformaDetail.Precio_Venta - this.ProformaDetail.Valor_Venta
    ).toFixed(2);
    this.ProformaDetail.Valor_Venta =
      //Number(this.formTEM.controls["VNPP"].value) / 1.18; // TRANSFORMO VNPP DE VUELTA A NUMBER PARA PORDER HACER LOS CALCULOS
      this.formTEM.controls["VNPP"].value / 1.18;
    this.ProformaDetail.Fecha_de_Pago = this.datepipe.transform(
      new Date(),
      "yyyy-MM-dd hh:mm:ss"
    );
    this.ProformaDetail.Plazo = this.formTEM.controls["Plazo"].value;
    //this.ProformaDetail.VNPP = Number(this.formTEM.controls["VNPP"].value); // TRANSFORMO VNPP DE VUELTA A NUMBER PARA PORDER HACER LOS CALCULOS
    this.ProformaDetail.VNPP = this.formTEM.controls["VNPP"].value;
    this.ProformaX.SimuladorDetalle.push(this.ProformaDetail);
    this.isLoading = true;
    this.disableDownload = true;
    this.proformaService.guardarProforma(this.ProformaX, 1).subscribe(
      resp => {
        let proforma = resp;
        this.ProformaCompleta = resp;
        this.resProforma = JSON.stringify(this.form.value);
        this.showResProforma = true;
        //enviar correo
        let $body: any;
                  $body = { 'urlSimulador': this.ProformaCompleta["Url_Simulador"],
                            'nombre': localStorage.getItem('Nombre'),
                            'correo': localStorage.getItem('email'),
                            'rucProv': localStorage.getItem('rucProv'),
                            'rucAdqui': localStorage.getItem('rucAdqui'),
                            'celular': localStorage.getItem('celular'),
                            'nroDoc': localStorage.getItem('NroDoc')};

                  this.proformaService.enviarProformaCliente($body).subscribe(
                    res => {
                      //this.showNotification('success', 'top', 'right', 'Correo enviado exitosamente.');
                    }, err => {
                      let error = "";
                      error = err.error.error;
                      //this.showNotification('warning', 'top', 'right', 'Error al intentar enviar correo. \n Error: ' + error);
                    }
                  );
        //fin enviar correo
        this.arrSimuladorFinal = {
          Url_Simulador: this.ProformaCompleta["Url_Simulador"],
          UrlResumen_Simulador: this.ProformaCompleta["UrlResumen_Simulador"],
          tipoCambio: this.formTEM.controls["TipoCambio"].value,
          VNPP: this.formTEM.controls["VNPP"].value,
          Interes: this.ProformaDetail.Interes,
          Desembolso: this.ProformaDetail.Desembolso,
          Remanente: this.ProformaDetail.Remanente
        };
        this.isLoading = false;
        this.disableDownload = false;
        this.loading = false;
      },
      err => {
        this.loading = false;
        this.isLoading = false;
        console.log("Error guardar simulador: ", err);
      }
    );
  }

  obtenerTEM() {
    this.formTEM.controls["VNPP"].setValue(this.cortarComa(this.formTEM.controls["VNPP"].value));
    this.loading = true;
    this.proformaService.obtenerTEM(this.formTEM.value, 1).subscribe(
      data => {
        this.TEM = Number(data);
        this.ProformaX.TEM = this.TEM;
        this.ProformaX.TEM_Sistema = this.TEM;
        this.Factoring();
        this.isValid = 1;
        localStorage.setItem("isValid", this.isValid.toString());
        this.stepper.selected.completed = true;
        this.stepper.next();
      },
      err => {
        this.loading = false;
        console.log("Error obteenr TEM: ", err);
      }
    );
  }

  Factoring() {
    let nroFacturas = 0;
    this.ProformaConDetalle.pPAdelanto =
      this.formTEM.controls["Adelanto_Porcentaje"].value / 100;
    this.ProformaConDetalle.TEM = this.TEM;
    this.ProformaConDetalle.VNPP = this.formTEM.controls["VNPP"].value;
    this.ProformaConDetalle.Plazo = this.formTEM.controls["Plazo"].value;
    this.ProformaConDetalle.Moneda = this.formTEM.controls["TipoCambio"].value;
    this.isLoading = true;
    this.disableDownload = true;
    this.proformaService.factoring(this.ProformaConDetalle, 1).subscribe(
      resp => {
        this.ProformaDetail.Adelanto = resp["Adelanto"];
        this.ProformaDetail.Remanente = resp["Remanente"];
        this.ProformaDetail.Desembolso = resp["Desembolso"];
        this.ProformaDetail.Comision = resp["Comision"];
        this.ProformaDetail.Interes = resp["Interes"];
        this.ProformaDetail.IGV = resp["IGV"];
        this.ProformaX.Comision_Importe = resp["Comision"];
        this.ProformaX.IGV_Importe = this.ProformaDetail.IGV_Factura_Importe;
        this.ProformaX.Desembolso_Importe = resp["Desembolso"];
        this.ProformaX.Remanente_Importe = resp["Remanente"];
        this.ProformaX.Adelanto_Importe = resp["Adelanto"];
        this.ProformaX.Interes_Importe = resp["Interes"];
        this.guardarProforma();
      });
    if (this.ProformaDetail.length == nroFacturas) {
      this.proformaService.factoringResume(this.ProformaDetail, 1).subscribe(
        resp => {
          let com = resp;
          this.ProformaDetail.Comision =
            Math.round(
              this.ProformaDetail.Adelanto * com["Comision_peso"] * 100
            ) / 100;
          this.ProformaDetail.IGV =
            Math.round(
              (this.ProformaDetail.Interes + this.ProformaDetail.Comision) *
              0.18 *
              100
            ) / 100;
          this.ProformaDetail.Desembolso =
            Math.round(
              (this.ProformaDetail.Adelanto -
                (this.ProformaDetail.Interes +
                  this.ProformaDetail.Comision +
                  this.ProformaDetail.IGV)) *
              100
            ) / 100;
        },
        err => {
          this.loading = false;
          this.isLoading = false;
          console.log("Error Factoring: ", err);
        }
      );
    }
  }

  cargarResumen() {
    this.isLoading = true;
    this.evaluacionService.subscriber$.subscribe(
      res => {
        this.isLoading = false;
        this.arrSimuladorFinalResumen = res;
      },
      err => {
        this.isLoading = false;
        console.log("error: ", err);
      }
    );
    this.isValid = 0;
    localStorage.setItem("isValid", this.isValid);
  }

  volver() {
    this.isValid = 0;
    localStorage.setItem("isValid", this.isValid);
    this.router.navigate(['evalua-tu-factura']);
  }

  generarPDFProforma() {
    this.generandoPdf = true;
    window.open(this.arrSimuladorFinal.Url_Simulador, "_blank");
    window.open(this.arrSimuladorFinal.UrlResumen_Simulador, "_blank");
  }

  tranformarDecimal(control: any, decimal?: number) {
    let valor;
    if (decimal) {
      valor = this.decimalPipe.transform(
        this.cortarComa(this.formTEM.controls[`${control}`].value),
        `1.${decimal}-${decimal}`
      );
    } else {
      valor = this.decimalPipe.transform(
        this.cortarComa(this.formTEM.controls[`${control}`].value),
        `1.2-2`
      );
    }
    this.formTEM.controls[`${control}`].setValue(valor);
  }

  cortarComa(numero: any): number {
    try {
      let cortado = numero.toString().replace(/,/gi, "");
      return Number(cortado);
    } catch (error) {
      return 0;
    }
  }

  showNotification(type, from, align, message) {

    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal

    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}
